module.exports = __webpack_public_path__ + "static/image7-a06f483b98b3eb816c0255c9d9cdc881.jpg";